import "@/App.css";
import { useLayoutEffect, lazy, Suspense } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Header } from "./components/Header";
import { Footer } from "./components/Footer";
import { CookieConsent } from "./components/CookieConsent";

// Pages - Lazy Loaded
const HomePage = lazy(() => import("./pages/HomePage").then(mod => ({ default: mod.HomePage })));
const WebsiteDevelopmentPage = lazy(() => import("./pages/WebsiteDevelopmentPage").then(mod => ({ default: mod.WebsiteDevelopmentPage })));
const WhatWeDoBuild = lazy(() => import("./components/WhatWeDoBuild").then(mod => ({ default: mod.WhatWeDoBuild })));
const WhatWeDoConsult = lazy(() => import("./components/WhatWeDoConsult").then(mod => ({ default: mod.WhatWeDoConsult })));
const WhatWeDoHire = lazy(() => import("./components/WhatWeDoHire").then(mod => ({ default: mod.WhatWeDoHire })));
const ProductDevelopmentPage = lazy(() => import("./pages/ProductDevelopmentPage").then(mod => ({ default: mod.ProductDevelopmentPage })));
const HireEngineersPage = lazy(() => import("./pages/HireEngineersPage").then(mod => ({ default: mod.HireEngineersPage })));
const CandidateSignupPage = lazy(() => import("./pages/CandidateSignupPage").then(mod => ({ default: mod.CandidateSignupPage })));
const AboutPage = lazy(() => import("./pages/AboutPage").then(mod => ({ default: mod.AboutPage })));
const CareersPage = lazy(() => import("./pages/CareersPage").then(mod => ({ default: mod.CareersPage })));
const ContactPage = lazy(() => import("./pages/ContactPage").then(mod => ({ default: mod.ContactPage })));
const PartnersPage = lazy(() => import("./pages/PartnersPage").then(mod => ({ default: mod.PartnersPage })));

// Legal Pages - Lazy Loaded
const PrivacyPolicyPage = lazy(() => import("./pages/legal/PrivacyPolicyPage").then(mod => ({ default: mod.PrivacyPolicyPage })));
const TermsPage = lazy(() => import("./pages/legal/TermsPage").then(mod => ({ default: mod.TermsPage })));
const CookiePolicyPage = lazy(() => import("./pages/legal/CookiePolicyPage").then(mod => ({ default: mod.CookiePolicyPage })));
const ImpressumPage = lazy(() => import("./pages/legal/ImpressumPage").then(mod => ({ default: mod.ImpressumPage })));
const CandidateConsentPage = lazy(() => import("./pages/legal/CandidateConsentPage").then(mod => ({ default: mod.CandidateConsentPage })));
const DPAPage = lazy(() => import("./pages/legal/DPAPage").then(mod => ({ default: mod.DPAPage })));

function ScrollToTop() {
  const { pathname } = useLocation();

  useLayoutEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function LoadingFallback() {
  return (
    <div className="flex items-center justify-center min-h-screen bg-white">
      <div className="text-center">
        <div className="inline-block">
          <div className="animate-spin rounded-full h-12 w-12 border-2 border-slate-300 border-t-indigo-600"></div>
        </div>
        <p className="mt-4 text-slate-600 font-medium">Loading...</p>
      </div>
    </div>
  );
}

function App() {
  return (
    <div className="App min-h-screen bg-white">
      <BrowserRouter basename="/buildandhire">
        <ScrollToTop />
        <Header />
        <main>
          <Suspense fallback={<LoadingFallback />}>
            <Routes>
              {/* Main Pages */}
              <Route path="/" element={<HomePage />} />
              <Route path="/services/build" element={<WhatWeDoBuild />} />
              <Route path="/services/consult" element={<WhatWeDoConsult />} />
              <Route path="/services/hire" element={<WhatWeDoHire />} />
              <Route path="/services/website-development" element={<WebsiteDevelopmentPage />} />
              <Route path="/services/product-development" element={<ProductDevelopmentPage />} />
              <Route path="/services/hire-engineers" element={<HireEngineersPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/careers" element={<CareersPage />} />
              <Route path="/careers/apply" element={<CandidateSignupPage />} />
              <Route path="/ourwork" element={<PartnersPage />} />
              <Route path="/contact" element={<ContactPage />} />

              {/* Legal Pages */}
              <Route path="/legal/privacy-policy" element={<PrivacyPolicyPage />} />
              <Route path="/legal/terms" element={<TermsPage />} />
              <Route path="/legal/cookies" element={<CookiePolicyPage />} />
              <Route path="/legal/impressum" element={<ImpressumPage />} />
              <Route path="/legal/candidate-consent" element={<CandidateConsentPage />} />
              <Route path="/legal/dpa" element={<DPAPage />} />
            </Routes>
          </Suspense>
        </main>
        <Footer />
        <CookieConsent />
      </BrowserRouter>
    </div>
  );
}

export default App;
